import React, { useState, useEffect } from 'react';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import styles from './PromoModal.module.scss';
import CloseWhite from '../../../src/assets/icons/closeWhite.svg';
import { isMobile } from '../../../src/utils/mobileOptimizer';

const DEFAULTS = {
  titleLine1: '',
  buttonText: 'Explore',
};

export default function PromoModal({ fields }) {
  const _isMobile = isMobile();
  const [isVisible, setIsVisible] = useState(false);
  // 禁用页面滚动
  const disableBodyScroll = () => {
    document.body.classList.add(styles.bodyNoScroll);
  };
  // 恢复页面滚动
  const enableBodyScroll = () => {
    document.body.classList.remove(styles.bodyNoScroll);
  };
  const showTime = fields?.showTime?.value; // (2025-11-18T16:00:00Z)
  const desktopImageValue =
    fields?.desktopImage && fields.desktopImage.value ? fields.desktopImage.value : '';
  const mobileImageValue =
    fields?.mobileImage && fields.mobileImage.value ? fields.mobileImage.value : '';
  // 时间比较逻辑
  const shouldShowModal = () => {
    if (!showTime) return false;
    try {
      const showDateTime = new Date(showTime);
      const currentDateTime = new Date();
      return showDateTime > currentDateTime;
    } catch (error) {
      console.error('Error parsing showTime:', error);
      return false;
    }
  };
  // onClose事件处理
  const onClose = () => {
    setIsVisible(false);
    // enableBodyScroll(); // 关闭时恢复滚动
  };
  // 组件挂载时检查是否应该显示
  useEffect(() => {
    const showModal = shouldShowModal();
    setIsVisible(showModal);
    if (showModal) {
      // disableBodyScroll(); // 显示时禁用滚动
    }
  }, [showTime]);
  // 如果没有显示时间字段或不应该显示，则不渲染任何内容
  if (!isVisible) {
    return null;
  }
  const currentImageValue = _isMobile ? mobileImageValue : desktopImageValue;
  const hasImage = !!(currentImageValue && currentImageValue.src);
  const urlHref = fields?.url?.value?.href
    ? `${fields.url.value.href}${fields.url.value.querystring || ''}`
    : '';
  const urlText = fields?.url?.value?.text || DEFAULTS.buttonText;
  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={_isMobile ? `${styles.content} ${styles.mobile}` : styles.content}>
          <button className={styles.closeButton} onClick={onClose} aria-label="Close modal">
            <img src={CloseWhite} alt={'x'} />
          </button>
          <div className={styles.flexBox}>
            {hasImage && (
              <div className={styles.imageBox}>
                <img
                  src={currentImageValue.src}
                  alt={currentImageValue.alt || '宣传图片'}
                  width="450"
                  height="650"
                />
              </div>
            )}
            <div className={styles.textBox}>
              <div className={styles.textTitle}>
                <span className={styles.titleLine}>
                  {fields?.titleLine1?.value || DEFAULTS.titleLine1}
                </span>
                <RichText field={fields?.titleLine2RichText} className={styles.titleLine} />
              </div>
              <RichText field={fields?.dateRichText} className={styles.dateRichText} />
              <RichText
                field={fields?.descriptionRichText}
                className={styles.descriptionRichText}
              />
              <a href={urlHref || undefined} className={styles.textBtn}>
                {urlText}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
